import * as React from 'react';
import { merge } from '../../utils/utility';
import { InputProps, withField } from './Field';
import { baseInputClass } from '../CommonClasses';
import { FiX } from 'react-icons/fi';

interface TextInputProps extends InputProps<string> {
  placeholder?: string;
  type?: string;
  clearable?: boolean;
  containerClassName?: string;
}

export const TextInput: React.FC<TextInputProps> = ({
  className,
  name,
  onChange,
  value,
  placeholder,
  Icon,
  clearable,
  containerClassName,
  type = 'text',
  ...props
}) => {
  const showClearButton = clearable && !!value;

  return (
    <div className={merge(containerClassName, 'relative')}>
      {Icon && <Icon className="absolute top-1/2 -translate-y-1/2 left-3 w-4 h-4 text-primary-900" />}
      <input
        {...props}
        type={type}
        name={name}
        id={name}
        className={merge(Icon ? 'pl-8' : '', showClearButton ? 'pr-8' : '', baseInputClass, 'w-full h-full', className)}
        placeholder={placeholder}
        value={value}
        onChange={event => onChange(event.target.value)}
      />
      {showClearButton && (
        <button className="absolute top-1/2 -translate-y-1/2 right-3" onClick={() => onChange('')}>
          <FiX className="w-5 h-5 text-primary-900" />
        </button>
      )}
    </div>
  );
};

export const TextField = withField(TextInput);
